import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Popper as MuiPopper,
  Paper,
} from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledPopper = styled(MuiPopper)(() => ({
  bottom: "15px !important",
}))

export const StyledDialogTitle = styled(DialogTitle)(
  ({
    theme: {
      typography: { pxToRem },
    },
  }) => ({
    color: "#757575",
    fontSize: pxToRem(20),
    fontWeight: "700",
    padding: `${pxToRem(27)} ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(30)}`,
  }),
)

export const StyledDialogContent = styled(DialogContent)(
  ({
    theme: {
      typography: { pxToRem },
    },
  }) => ({
    "&.MuiDialogContent-root": {
      "& .MuiDialogContentText-root": {
        color: "rgba(0, 0, 0, 0.54)",
        fontSize: pxToRem(13),
      },
      fontSize: pxToRem(14),
      height: "35%",
      minHeight: "65px",
      padding: `${pxToRem(8)} ${pxToRem(24)} ${pxToRem(8)} ${pxToRem(30)}`,
    },
  }),
)

export const StyledDialogActions = styled(DialogActions)(
  ({
    theme: {
      typography: { pxToRem },
    },
  }) => ({
    "& > :not(:first-of-type)": {
      marginLeft: pxToRem(26),
    },
    justifyContent: "flex-start",
    padding: `${pxToRem(30)} ${pxToRem(30)}`,
  }),
)

export const StyledPaper = styled(Paper)(({ maxheight, overflow }) => ({
  backgroundColor: "#ececec",
  border: "none",
  borderRadius: "4px",
  height: maxheight ? maxheight : "",
  maxHeight: maxheight ? maxheight : "calc(100% - 64px)",
  minWidth: 720,
  overflowY: overflow ? "visible" : undefined,
}))

export const StyledDialogContentText = styled(DialogContentText)(() => ({}))
